import type { Feature } from '@luna/gatekeeper';

export const prepaidCardInfo: Feature = {
    enabled: true,
    _description: 'Displays prepaid info card in the functions page',
};
